export default {
  title: "New Event",
  name: "Event Name",
  date: "Date of Event",
  collaboratorEmail: "Email of Collaborator (Optional)",
  photo: "Logo (Optional)",
  next: "NEXT",
  update: "UPDATE",
  back: "Cancel",
  timezone: "Timezone",
};



// WEBPACK FOOTER //
// ./src/components/forms/project-form-update/ProjectFormUpdate.messages.js